import React from "react";
import { SxProps, useTheme } from "@mui/material/styles";
import { CustomButton, CustomButtonText, ButtonSwitchContainer } from "./ButtonSwitch.styles";
import { SizeStyles, Variants } from "./ButtonSwitch.variants";


export interface CustomVariantButtonSwitchProps {
    variant?: "primary" | "secondary";
    value?: boolean | undefined;
    disabled?: boolean;
    error?: boolean;
    size?: "sm" | "md" | "lg";
    leftButtonChildren: React.ReactNode;
    rightButtonChildren: React.ReactNode;
    active?: "left" | "right";
    onLeftButtonClick?: () => void;
    onRightButtonClick?: () => void;
    sx?: SxProps;
}

export const ButtonSwitch = ({
    variant = "primary",
    value = undefined,
    disabled = false,
    error = false,
    size = "md",
    leftButtonChildren = "Left",
    rightButtonChildren = "Right",
    active,
    sx,
    onLeftButtonClick,
    onRightButtonClick
}: CustomVariantButtonSwitchProps) => {
    const theme = useTheme();
    
    const [isAnOptionSet, setIsAnOptionSet] = React.useState<boolean>(active ? true : false);
    const [switchButton, setSwitchButton] = React.useState<boolean>(active === "left" ? true : false);
    
    const variantStylesFn = Variants(theme);
    const sizeStylesFn = SizeStyles(theme);

    return (
        <ButtonSwitchContainer  
            sx={{
                ...variantStylesFn[variant],
                ...sx,
                border: error ? '1px solid red' : 'none',
                pointerEvents: disabled ? 'none' : 'auto'
            }}
        >
            <CustomButton
                sx={{
                    ...sizeStylesFn[size],
                }}
                className={(isAnOptionSet && switchButton && typeof value === "undefined") || value === true ? 'is-Selected left' : 'left'}
                onClick={() => {
                    setIsAnOptionSet(true);
                    setSwitchButton(true);
                    if (onLeftButtonClick) {
                        onLeftButtonClick();
                    }
                }}
            >
                <CustomButtonText>
                    {leftButtonChildren}
                </CustomButtonText>
            </CustomButton>
            <CustomButton
                sx={{
                    ...sizeStylesFn[size],
                }}
                className={(isAnOptionSet && !switchButton && typeof value === "undefined") || value === false ? 'is-Selected right' : 'right'}
                onClick={() => {
                    setIsAnOptionSet(true);
                    setSwitchButton(false);
                    if (onRightButtonClick){
                        onRightButtonClick();
                    } 
                }}
            >
                <CustomButtonText>
                    {rightButtonChildren}
                </CustomButtonText>
            </CustomButton>
        </ButtonSwitchContainer>
    );
};

export interface ButtonSwitchProps extends React.ComponentProps<typeof ButtonSwitch> {
    as?: React.ElementType;
}

ButtonSwitch.displayName = "ButtonSwitch";
